module.exports = __webpack_public_path__ + "static/media/notley.727c3b39.svg";